import { DisconnectionFormValues } from "../types/DisconnectionFormValues";
import { EMPTY_METER_VALUES } from "./DisconnectionMeterValues";
import { EMPTY_CONTACT_DETAILS_VALUES } from "./EmptyContactDetailsValues";

export const EMPTY_DISCONNECTION_ORDER: DisconnectionFormValues = {
  isUserLoggedIn: false,
  propertyDetails: {
    icpAddressLookupEnabled: true,
    icpAddressLookup: {
      id: "",
      label: "",
    },
    meterInfo: {
      meterCount: 1,
      meters: [EMPTY_METER_VALUES],
      addressInformation: {
        streetAddress: "",
        streetAddressId: "",
        manuallyEnteredAddress: false,
        manualStreetAddress: {
          streetNumber: "",
          streetName: "",
          suburb: "",
          unit: "",
          postcode: "",
        },
        additionalAddressInformation: "",
      },
    },
    type: "",
    guardDogs: false,
    lockedGate: false,
  },
  disconnectionDetails: {
    removalReason: "",
    disconnectionDate: "",
    hasTenants: "",
    hazards: "",
    otherInformation: "",
    filesUploadStatus: "",
    meterPhotos: [],
  },
  contactDetails: {
    requester: {
      ...EMPTY_CONTACT_DETAILS_VALUES,
      workContactPreferences: { email: true, sms: false },
    },
    propertyOwnerSameAsRole: "",
    propertyOwner: {
      ...EMPTY_CONTACT_DETAILS_VALUES,
    },
    siteContactSameAsRole: "",
    siteContact: {
      ...EMPTY_CONTACT_DETAILS_VALUES,
    },
  },
  declarations:[]
};
